import React from 'react';
import _isEmpty from 'lodash.isempty';
import ReactLoading from 'react-loading';
// components
import ChecklistHeader from '../components/ChecklistHeader';
import ChecklistBody from '../components/ChecklistBody';

import { Container, Grid, Segment, Message } from 'semantic-ui-react';

// React component
class SingleChecklistView extends React.Component {
	componentDidMount() {
		// only fetch single list if not already loaded before
		if (_isEmpty(this.props.list)) {
			// get the id from router's wildcard
			const { id } = this.props.match.params;
			console.log(`id before fetching: ${id.toLowerCase()}`);
			this.props.fetchLists(id);
		}

		// Get user id from query string
		const parsedUserId = this.props.location.search.slice(8);

		// only fetch data if not already fetched
		// userId must not be empty or undefined
		if (this.props.userLoaded === false && parsedUserId !== '' && typeof parsedUserId !== 'undefined') {
			this.props.fetchUser(parsedUserId);
		}
	}

	render() {
		if (this.props.error) {
			return <div>Error</div>;
		} else if (this.props.loading) {
			return (
				<Grid className="middle aligned">
					<Grid.Row centered>
						<Grid.Column desktop={4} tablet={8} mobile={16}>
							<div className="loading-container row align-center align-middle">
								<ReactLoading
									type="balls"
									color="rgba(40,40,40,0.75)"
									className="react-loading-animation"
									width={100}
								/>
							</div>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			);
		} else {
			let { title: listTitle, list_id: listId } = this.props.list;

			return (
				<Container text id="responsive-container">
					<Grid columns={1}>
						<Grid.Row centered>
							<Grid.Column mobile={16} tablet={14} computer={12} id="full-width-col">
								<Segment raised>
									{this.props.showMsgStarredMaximum === true && (
										<Message
											header="Maximum erreicht"
											content="Du kannst maximal sechs Checklisten als Favoriten markieren."
											color="red"
											floating="true"
										/>
									)}

									<ChecklistHeader
										listId={listId}
										name={listTitle}
										backButton={true}
										goToButton={false}
									/>

									<ChecklistBody
										list={this.props.list}
										user={this.props.user}
										userLoaded={this.props.userLoaded}
									/>
								</Segment>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Container>
			);
		}
	}
}

export default SingleChecklistView;



// WEBPACK FOOTER //
// ./src/views/SingleChecklistView.js